import React from "react";
import PropTypes from "prop-types";

const SectionButton = ({ label, isActive, onClick, targetId }) => {
  return (
    <button
      className={`btn ${
        isActive ? "btn-primary" : "btn-outline-primary border border-light"
      }`}
      type="button"
      data-bs-toggle="collapse"
      data-bs-target={`#collapse${targetId}`}
      aria-expanded={isActive}
      aria-controls={`collapse${targetId}`}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

SectionButton.propTypes = {
  label: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  targetId: PropTypes.string.isRequired,
};

export default SectionButton;
